export function showTextToCopyDialog(textToCopy) {
    //TODO: mai
}